export default __webpack_public_path__ + "static/project4-63ee66d2d7978900353302e40a465d52.jpg";